export const DISPATCH = {
  LINE: {
    SELECTED: {
      TYPE: "LINE_SELECTED_TYPE"
    }
  },
  AGENT: {
    SELECTED: {
      TYPE: "AGENT_SELECTED_TYPE"
    }
  },
  CONVERSATION: {
    SELECTED: {
      TYPE: "CONVERSATION_SELECTED_TYPE",
    }
  },
};